import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/SpecificGravityCoarseWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';

const specificGravityProps = { format: { nearest: 0.001 } };
const temperatureProps = { uom: '°C', format: { nearest: 0.1 } };
const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.SoakingPeriod`]: { uom: 'h', format: { nearest: 0.1 } },

      [`${prefix}.TestPortions.ProportionOfSample`]: { format: { nearest: 0.1 } },
      [`${prefix}.TestPortions.WaterTemperatureReading`]: temperatureProps,
      [`${prefix}.TestPortions.WaterTemperatureCorrected`]: temperatureProps,
      [`${prefix}.TestPortions.SpecificGravityOvenDry`]: specificGravityProps,
      [`${prefix}.TestPortions.SpecificGravitySSD`]: specificGravityProps,
      [`${prefix}.TestPortions.ApparentSpecificGravity`]: specificGravityProps,
      [`${prefix}.TestPortions.Absorption`]: { format: { nearest: 0.01 } },

      [`${prefix}.Results.SpecificGravityOvenDry`]: specificGravityProps,
      [`${prefix}.Results.SpecificGravitySSD`]: specificGravityProps,
      [`${prefix}.Results.ApparentSpecificGravity`]: specificGravityProps,
      [`${prefix}.Results.Absorption`]: { format: { nearest: 0.01 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 0.1, defaultUom: 'g' },
    }
  );

export { getConfig };
export default {
  [qestIds.specificGravityCoarse.AASHTO_T_85.rev2014]: getConfig,
};
